import { setRegisteredData } from "./registered-data";

$('.application-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    $('section#application .page').prop('hidden', true);
    $('section#application .page-game').prop('hidden', false);
    $('section#application .result').prop('hidden', true);

    $(`section#application .result-${data.prize ? 'success' : 'failed'}`).prop('hidden', false);
    if (data.prize) {
        $('.result-prize-name').html(data.prize.name);
        $('.result-form-link').attr('href', data.formUrl);
    }
    setRegisteredData(data, 'section#application');
});

$('.game-run').on('click', function() {
    // page swap
    $('section#application .page').prop('hidden', true);
    $('section#application .page-result').prop('hidden', false);

    // modal (uncomment if you need a modal instead of page swap)
    //$('#modal-form-application').modal('show');
});

$('.result-try-again').on('click', function() {
    $('section#application .page').prop('hidden', true);
    $('section#application .page-form').prop('hidden', false);
});

$('[name="billType"]').on('change', function() {
    $('[name="billPos"]', this.form.elements).closest('.form-group').prop('disabled', $(this).val() != 'Paragon');
}).trigger('change');